/** @format */
import { useContext, useMemo } from 'react';

import { getConfig } from '@toucan/helpers/settings';

import { cloudflareLoader } from '@toucan/hooks/use-responsive-loader/cloudflare-loader';
import { contentfulLoader } from '@toucan/hooks/use-responsive-loader/contentful-loader';
import {
    ResponsiveLoader,
    ResponsiveLoaderType,
} from '@toucan/hooks/use-responsive-loader/types';

import { MarketContext } from '@toucan/client/global/market';

export const useResponsiveLoader = (
    loaderType?: ResponsiveLoaderType
): ResponsiveLoader => {
    const { activeMarket } = useContext(MarketContext);
    const { publicRuntimeConfig } = getConfig();

    return useMemo(() => {
        switch (loaderType) {
            case ResponsiveLoaderType.CLOUDFLARE: {
                const isResizeEnabled = Boolean(
                    publicRuntimeConfig?.cloudflareImageResizeEnabled
                );

                if (isResizeEnabled) {
                    return {
                        loader: cloudflareLoader,
                        isLoaderEnabled: true,
                    };
                }

                return { loader: undefined, isLoaderEnabled: false };
            }
            case ResponsiveLoaderType.CONTENTFUL:
                return { loader: contentfulLoader, isLoaderEnabled: true };
            default:
                // Use built-in loader
                return { loader: undefined, isLoaderEnabled: true };
        }
    }, [
        loaderType,
        activeMarket?.code,
        publicRuntimeConfig?.cloudflareImageResizeEnabled,
    ]);
};
